import React from "react";
import Header from "../../components/Header";
import FooterTwo from "../../components/Footer/FooterTwo";
import Breadcrumb from "../../components/Breadcrumb";
import InstructorMain from "./InstructorMain";
import ScrollToTop from "../../components/ScrollTop";
import DownloadApp from "../home/DownloadApp";

const Instructor = () => {
  return (
    <>
      <Header parentMenu="about" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle="Meet Our Team" />
          <InstructorMain />
          {/* download-app-start */}
          <DownloadApp />
          {/* download-app-end */}
          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <FooterTwo />
    </>
  );
};

export default Instructor;
